// extracted by mini-css-extract-plugin
export default {"collectionText":"CollectionsPage_collectionText__ZzM4V","listOfCollections":"CollectionsPage_listOfCollections__4O2qK"};